import { render, staticRenderFns } from "./UserManageRegister.vue?vue&type=template&id=12994d4a&scoped=true"
import script from "./UserManageRegister.vue?vue&type=script&lang=js"
export * from "./UserManageRegister.vue?vue&type=script&lang=js"
import style0 from "./UserManageRegister.vue?vue&type=style&index=0&id=12994d4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12994d4a",
  null
  
)

export default component.exports